    <div class="wrong-account">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     [iconType]="'unlink'"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
        <div class="wrong-account__description"
             [innerHtml]="
            'Impossible de consulter cette invitation depuis le compte <span class=\'email\'>$mail$ !</span>' | transloco: {
            mail: user.email
            }">
        </div>
        <mat-card class="wrong-account__card card">
            <mat-card-content>
                <div class="block-content">
                    <div class="block-content__icon text-center margin-bottom-30">
                        <span class="icon icon-warning warning icon-size-25"></span>
                    </div>
                    <div class="block-content__text text-center margin-bottom-50"
                         [innerHtml]="
                    'Pour continuer, vous devez etre connecte au compte Infomaniak avec l\'utilisateur <br/><strong>$account$</strong>.' | transloco: {
                    account: invitation.email
                    }">
                    </div>
                    <div class="
                    block-content__buttons
                    text-center">
                        <a mat-raised-button
                           color="primary"
                           (click)="changeAccount()">
                            {{ ('Changer de compte' | transloco) }}
                        </a>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
